<template>
	<!-- 弹出向导层 start-->
	<div id="pop" class="pop" v-bind:style="{ width: screenWidth+'px', height: screenHeight + 'px' }" v-show="pop_show">
		<span class="pop_bg" @click="closeshow()"></span>

		<div id="pop_bodyup" class="pop_content">
			<!-- 动态查询区生成 -->
			<div class="pop_children">
				<div class="pop_head_close">
					<a class="close" href="javascript:void(0);" @click="closeshow()"></a>
				</div>
				<div>
					<h5>{{sheet_no}}配套照片</h5>
				</div>
				<div class="content_edit">
					<div class="content_edit_item">
						<button class="pre_btn_ok" @click="refresh_data()">
							刷新
						</button>&nbsp;
						<button class="pre_btn_ok" @click="fun_upd('new')">
							新增
						</button>&nbsp;
						<button class="pre_btn_ok" @click="fun_upd('add')">
							保存
						</button>&nbsp;
						<button class="pre_btn_ok btn_del" @click="fun_upd('del')">
							删除
						</button>&nbsp;
						<button class="pre_btn_ok" @click="fun_sel_file()">
							选择文件
						</button>&nbsp;
						<button class="pre_btn_ok" @click="fun_look_file()">
							预览文件
						</button>&nbsp;
						<button v-show="show_btn" class="pre_btn_ok btn_del" @click="fun_del_file()">
							删除文件
						</button>&nbsp;
						<button class="pre_btn_ok" @click="fun_up_file()">
							上传文件
						</button>
					</div>
				</div>

				<div class="content_edit">
					<div class="content_edit_item">
						<label>文件名称:</label>
						<input type="text" v-model="f_name" style="width: 128px;" />
					</div>
					<div class="content_edit_item">
						<label>文件类型:</label>
						<input type="text" v-model="sel_f_name" placeholder="选择类型"
							style="width: 108px;display: inline-block;vertical-align: middle;" />
						<el-select v-model="sel_f_id" clearable placeholder="待选" @change="choseValue($event)"
							style="width: 108px;display: inline-block;vertical-align: middle;">
							<el-option v-for="item in list_type" :key="item.id" :label="item.val" :value="item.id">
							</el-option>
						</el-select>
					</div>
				</div>
				<div class="content_edit">
					<div class="content_edit_item">
						<label>备注:</label>
						<input type="text" v-model="f_note" style="width: 384px;" />
					</div>
				</div>
				<div class="content_edit" v-show="file_name!=''">
					<div class="content_edit_item">
						<label>文件:</label>{{file_name}}&nbsp;&nbsp;{{file_up}}
					</div>
				</div>


				<table class="dataintable tanfile" border="1" cellpadding="2" cellspacing="1">

					<tr class="tab_header_new">
						<td>序号</td>
						<td>单号</td>
						<td>名称</td>
						<td>类型</td>
						<td>备注</td>
						<td>附件</td>
						<td>大小</td>
						<td>上传人</td>
						<td class="long1">更新时间</td>
						<td>操作</td>
					</tr>

					<tr :id="'f'+item.row_num" v-for="(item, index) in list_file" :key="index" @click="sel_row(item)">
						<td>{{ item.row_num }}</td>
						<td>{{ item.sheet_no }}</td>
						<td>{{ item.f_name }}</td>
						<td>{{ item.c_name }}</td>
						<td>{{ item.note }}</td>
						<td class="short0 cen">
							<el-image v-show="item.f_url!=''" style="width: 20px; height: 20px"
								:src="check_url(item.f_url)" :preview-src-list="[check_url(item.f_url)]">
							</el-image>

							<el-image v-show="item.f_url==''">
								<div slot="error" class="image-slot">
									<i class="el-icon-picture-outline"></i>
								</div>
							</el-image>
						</td>
						<td class="short0">{{ item.f_size }}</td>
						<td class="short0">{{ item.u_name }}</td>
						<td class="long1">{{ item.sys_date }}</td>
						<td>
							<button class="pre_btn_ok btn_del" @click="fun_del_file(item)"  v-show="show_btn">删除附件</button>
						</td>
					</tr>

				</table>
			</div>
		</div>

		<!-- 文件预览部分 -->
		<!-- 弹出向导层 预览 与 下载 start-->
		<!-- <input class="displayno" type="file" id="savefileMODE" v-on:change="getFilePath" multiple="multiple" /> -->
		<input class="displayno" type="file" id="savefileMODE" v-on:change="getFilePath" />

		<a id="downlink"></a>
		<a id="loodlink" target="_blank"></a>

		<!-- 		<vue-viewer style="display: inline-block" :thumb="image" :full="image">
		</vue-viewer> -->

	</div>
</template>

<script>
	import api from '@/utils/type.js';
	import {
		Sel_page_and_length,
		Method_EasyUpdate,
		Method_Common,
		Method_EasySelect
	} from '@/utils/loadhttpdata.js';

	// 文件操作辅助方法
	import {
		base_encode
	} from "@/utils/base64.js";
	import {
		GetShort,
		DeleteSpecialWord,
		BackSpecial,
		ChangeSpecial,
		GetRandom
	} from "@/utils/localstore.js";
	import {
		BrowserGet
	} from '@/utils/systemSelect.js';


	export default {
		name: "pre_tan_file",
		data() {
			return {
				element_loading: false,
				pop_show: false,
				show_btn: true,
				row_id: '',
				sys_date: '',
				
				sel_action: '',
				upd_action: '',

				title: '',
				sheet_no: "",
				mode_type: '',
				mode_name: '',
				sheet_flag: "",

				screenWidth: '',
				screenHeight: '',

				f_name: "",
				f_note: "",

				//文件
				file_name: "",
				file_data: "",
				file_up: "",
				file_url: "",
				file_src: "",
				file_size: "",
				file_type: '',
				file_action: '',
				blockSize: '',
				file_backdata: '',
				p1: '',
				p2: '',
				p3: '',

				list_file: [],

				sel_f_id: '',
				sel_f_name: '',
				list_type: '',

				radio: 1


			};
		},
		methods: {
			check_url: function(url) {
				let t = BackSpecial(url);
				// console.log(t);
				return t;
			},
			chang_style: function() {
				this.screenWidth = $(window).width();
				this.screenHeight = $(window).height(); //当前浏览器窗口的 宽高
			},
			showpop: function(parm) {
				this.pop_show = true;
				var Hg = $(document).height();
				// 设置背景高度
				$(".pop_bg").height(Hg);
				// 设置展示动画 第一次有慢入动作,第二次没有:原因是当前页面被缓存，除非重开
				$(".pop_bg").fadeIn("3000");
				$(".pop_content").fadeIn("3000");
				this.chang_style();
				this.load_data(parm)
			},
			closeshow: function() {
				this.pop_show = false;
				$(".pop_bg").fadeOut("3000");
				$(".pop_content").fadeOut("3000");
				this.screenHeight = 0;
				this.screenWidth = 0;
			},
			load_data: async function(res) {
				// console.log('初始参数', res);

				let r = res;
				// 清理缓存
				this.row_id = '';
				this.sel_action = '';
				this.file_action = '';

				this.title = r.title;
				this.sheet_no = r.sheet_no;
				this.sheet_flag=r.flag;

				this.sel_action = r.sel_action;
				this.upd_action = r.upd_action;
				this.file_action = r.file_action;

				let list_action = r.list_action;

				this.p1 = r.p1;
				this.p2 = r.p2;

				let date = new Date();
				var y = date.getFullYear();
				var m = date.getMonth() + 1;
				m = m < 10 ? ('0' + m) : m;
				var d = date.getDate();
				d = d < 10 ? ('0' + d) : d;
				// var h = date.getHours();
				// h = h < 10 ? ('0' + h) : h;
				// var minute = date.getMinutes();
				// minute = minute < 10 ? ('0' + minute) : minute;
				// this.file_time = y + '' + m + '' + d + '' + h + '' + m;
				this.p3 = y + '' + m + '' + d;


				if (r.flag == '已提交') {
					this.show_btn = false;
				} else {
					this.show_btn = true;
				}

				this.refresh_data();

				if (typeof(list_action) === 'undefined' || list_action == '') {
					return;
				}

				this.list_type = [];

				let backdata = await this.fun_load_class(list_action, '');
				// console.log(backdata)
				if (backdata.data.status == '1') {
					this.list_type = backdata.data.data;
				} else {
					this.$message({
						type: 'info',
						message: '没有查询到附件类型'
					});
				}



			},
			choseValue: async function(e, sel) {
				this.sel_f_id = 0;
				this.sel_f_name = '';

				for (let i = 0; i < this.list_type.length; i++) {
					if (this.list_type[i].id == e) {
						this.sel_f_name = this.list_type[i].val;
						this.sel_f_id = e;

						break;
					}
				}
			},
			fun_load_class: function(action, p1, p2) {
				let that = this;
				return new Promise((resolve, reject) => {
					// console.log(menuvalue);
					that.$post(
						api.http_method, Method_EasySelect(action, p1, p2)
					).then(res => {
						res = JSON.parse(res);
						resolve(res)
					});

				});
			},
			refresh_data: async function() {
				this.row_id = '';

				this.file_name = '';
				this.file_data = '';
				this.file_up = '';
				this.file_size = 0;
				this.file_type = '';

				this.file_url = '';
				this.file_src = '';

				this.element_loading = true;
				this.list_file = [];

				let r = (Math.random() + '').substring(0, 8);

				this.$post(
					api.http_method, Sel_page_and_length(this.sel_action, 1, 100, this.sheet_no)
				).then(res => {
					this.element_loading = false;
					res = JSON.parse(res);

					if (res.length > 0) {
						this.list_file = res[0];
						// console.log(this.list_file);
					} else {
						this.$message({
							message: '没有查询到数据!',
							type: 'warning'
						});
					}
				});
			},
			sel_row: function(item) {
				// console.log(item);
				this.row_id = item.id;
				this.sys_date = item.sys_date;
				this.sheet_no = item.sheet_no;

				this.f_name = item.f_name;
				this.f_note = item.note;

				this.sel_f_name = item.c_name;
				for (let i = 0; i < this.list_type.length; i++) {
					if (this.list_type[i].val == item.c_name) {
						this.sel_f_id = this.list_type[i].id;
						break;
					}
				}

				let tt = BackSpecial(item.f_url);
				tt = tt.substring(tt.lastIndexOf('/') + 1);
				this.file_name = tt;
				this.file_url = item.f_url;

				this.file_src = item.f_src;
				// console.log(this.file_url);
				// console.log(this.file_src);
				this.setCurrentRowJsonOld('f', item.row_num);
			},
			fun_clear: function() {
				// this.f_name = '';
				this.row_id = '';

				this.file_name = '';
				this.file_data = '';
				this.file_up = '';
				this.file_size = 0;
				this.file_type = '';

				this.file_url = '';
				this.file_src = '';

			},
			fun_upd: function(type) {
				// console.log('操作类型=' + type);
				if (type == 'new') {
					this.row_id = 0
					this.sys_date = ''
					type = 'add';
				}

				if (type == 'upd' || type == 'del' || type == 'sub' || type == 'bad') {
					if (this.row_id == 0) {
						this.$message({
							message: '请选择要编辑的数据!',
							type: 'warning'
						});
						return;
					}
				}


				let d = [];
				d.push(this.sheet_no); //标识
				d.push(this.f_name); //标识
				d.push(this.sel_f_id); //标识
				d.push(this.f_note)

				let r = (Math.random() + '').substring(0, 8);
				// console.log(d);
				let temp_data = '';
				temp_data = Method_Common(this.upd_action+'_'+ type, this.row_id, this.sys_date, d, r);

				this.$post(
					api.http_method, temp_data
				).then(res => {
					this.element_loading = false;
					res = JSON.parse(res);
					// console.log(res);
					if (res.data.status == 1) {
						this.$message({
							message: res.data.msg,
							type: 'success'
						});

						this.refresh_data();

					} else {
						this.$message({
							message: res.data.msg,
							type: 'warning'
						});
					}
				});

			},
			setCurrentRowJsonOld: function(key, id) {
				// console.log(this.list_file );
				for (var i = 0; i < this.list_file.length; i++) {
					// console.log(this.data_tab[i][1]);
					if (this.list_file[i].row_num == id) {
						document.getElementById(key + id).style.background = '#92a4f3';
					} else {
						if (this.list_file[i].row_num % 2 == 0) {
							document.getElementById(key + this.list_file[i].row_num).style.background = '#fff';
						} else {
							document.getElementById(key + this.list_file[i].row_num).style.background = '#f5f5f5';
						}
					}
				}
			},
			//附件操作 start //////////////////////////////////////
			// 点击上传附件
			fun_sel_file: function() {
				// console.log('点击选择附件=' + this.row_id);
				if (this.row_id == null || Number(this.row_id) == 0) {
					this.$message({
						dangerouslyUseHTMLString: true,
						message: '操作不正确1,请选择需要上传附件<div class="mtop mdown" > 附件名称=' + this.file_name +
							'</div>请检查!'
					});
					return;
				}
				// console.log(this.file_url);
				if (this.file_url != '') {
					this.$message({
						dangerouslyUseHTMLString: true,
						message: '操作不正确2,已经上传附件<div class="mtop mdown" > 名称=' + this.file_name + '</div>请检查!'
					});
					return;
				}

				this.file_name = '';
				this.file_data = '';
				this.file_up = '';
				this.file_size = 0;
				this.file_type = '';

				this.file_url = '';
				this.file_src = '';

				let fileobj = document.getElementById('savefileMODE');
				fileobj.click();
			},
			fun_look_file: function() {
				console.log('点击预览附件');
				if (this.file_url == null || String(this.file_url).length == 0 || String(this.file_url) == '') {
					this.$message({
						dangerouslyUseHTMLString: true,
						message: '操作不正确,已经上传附件<div class="mtop mdown" > 名称=' + this.file_name + '</div>请检查!'
					});
					return;
				}

				if (/\.(gif|jpg|jpeg|png|ico|pdf)$/.test(this.file_name.toLowerCase())) {
					// 会被火狐浏览器弹窗阻止,360和谷歌正常
					var pdfview = document.getElementById('loodlink');
					pdfview.href = this.file_url;
					// window.open(tv_url, '_blank'); //被弹窗阻止
					pdfview.click();

				} else {
					this.$message({
						message: '该类型文件暂不支持预览,将开始下载!',
						type: 'success'
					});

					let down_file = document.getElementById("downlink");
					let temp_url = BackSpecial(this.file_url);
					let temp_filename = BackSpecial(BackSpecial(temp_url.substring(temp_url.lastIndexOf('/') + 1)));
					down_file.download = this.file_name; // 下载名称
					down_file.href = temp_url; // 绑定a标签
					down_file.click(); // 模拟点击实现下载
				}
			},
			getFilePath: function() {
				let tmpFile = document.getElementById('savefileMODE');
				// console.log('点击选择结果');
				// console.log(tmpFile.files);
				if (typeof FileReader !== "undefined") {
					let max_size = 5000; // 50k 20M
					let name = '';
					let size = 0;
					let fileData = tmpFile.files[0];

					this.file_backdata = fileData;
					name = fileData.name;
					size = fileData.size;
					this.file_size = size;

					// console.log('名称=' + name + ' 大小=' + size);
					if (!(/\.(gif|jpg|jpeg|png|ico|pdf)$/.test(name.toLowerCase()))) {
						this.$message({
							message: '只可以上传图片、pdf、doc、docx、zip、rar格式',
							type: 'warning'
						});
						return;
					}
					this.file_name = name;

					if (size > max_size * 1024) {
						this.$message({
							message: '图片大小不能超过2M',
							type: 'warning'
						});
						return
					}
					// console.log(tmpFile);   //连标签原样输出了
					// console.log(tmpFile.value);   //图片路径

					let reader = new FileReader(); // FileReader
					let that = this;
					reader.readAsDataURL(fileData);
					reader.onload = function() {
						// 获取到base64图片内容
						that.file_data = this.result;
					}
					// console.log(size / 1024 + 'kB');
				} else {
					this.$message({
						message: '当前浏览器不支持上传组件',
						type: 'warning'
					});
				}

			},
			fun_del_file: async function(item) {
				console.log('点击删除附件'+this.sheet_flag);
				if (typeof(item) !== 'undefined' && item != '') {
					await this.sel_row(item);
				}

				if (this.sheet_flag == '已提交') {
					this.$message({
						message: '基础信息已经提交,不能删除相关附件!',
						type: 'warning'
					});
					return;
				}

				console.log('row_id=' + this.row_id);

				if (this.row_id == null || Number(this.row_id) == 0) {
					this.$message({
						message: '操作不正确1,请选择要删除的附件信息!',
						type: 'warning'
					});
					return;
				}

				if (this.file_url == '') {
					this.fun_del_file_two();
					return;
				}

				// 第一步 删除存储路径
				this.fun_del_file_two();
				// 第二步 删除真实文件
				this.fun_del_file_three(this.file_src);
			},
			fun_del_file_two: function() {
				var postdata = "";
				postdata =
					'{"action":"data_del_' + this.file_action + '","user_no":"' +
					GetShort("userno") +
					'","sheet_no":"' +
					this.sheet_no +
					'","rowid":"' +
					this.row_id +
					'"}';

				// console.log(postdata);
				postdata =
					'{"method":"File_NewSavePath","data":"' + base_encode(postdata) + '"}';

				this.$post(
					api.http_method, postdata
				).then(res => {
					res = JSON.parse(res);
					// console.log(res);
					this.$message({
						message: res.data.msg,
						type: 'success'
					});

					this.refresh_data();

				});

			},
			fun_del_file_three: function() {
				// console.log('删除路径 \r\n' + this.file_src);
				var postdata = '';
				postdata =
					'{"method":"File_del","data":"' + base_encode(this.file_src) + '"}';
				this.$post(
					api.http_method, postdata
				).then(res => {

					res = JSON.parse(res);
					// console.log(res);
					if (res.data.status == 1) {

						this.$message({
							message: BackSpecial(BackSpecial(res.data.msg)),
							type: 'success'
						});

					} else {
						this.$message({
							message: BackSpecial(BackSpecial(res.data.msg)),
							type: 'warning'
						});
					}
				});
			},
			fun_up_file: async function() {
				// 一块文件的大小
				this.blockSize = 1 * 1024 * 1024;
				// console.log('文件大小=' + this.file_data.length)
				if (this.file_data.length > 0) {
					let random_name = GetRandom();
					this.file_name = random_name + DeleteSpecialWord(this.file_name);

					await this.fun_up_file_max();
					// this.element_loading = false;
				} else {
					this.$message({
						message: '未发现上传文件!',
						type: 'warning'
					});
				}
			},
			fun_up_file_max: async function() {
				// 大于1M，分段上传
				let num = 1;
				let start = 0;
				let end = 0;
				let maxFileLength = 0;
				maxFileLength = this.file_backdata.size;
				console.log('原始文件总长度=' + maxFileLength + ' 标准块=' + this.blockSize);

				while (start < maxFileLength) {
					end = start + this.blockSize;
					if (end > maxFileLength) {
						end = maxFileLength;
					}


					let temp_data = '';
					temp_data = this.file_backdata.slice(start, end); //文件切片
					// console.log('上传长度=' + temp_data.size);
					// console.log(temp_data);
					// 上传出错则重新上传
					let res = '';
					try {
						res = await this.fun_up_file_block(temp_data);
						console.log(res);
						if (res.status == 1) {
							this.file_up = '数据块' + (num + 1) + '完成 总进度:' + ((end / maxFileLength) * 100).toFixed(2) +
								" %";
						} else {

						}
					} catch (error) {
						res = await this.fun_up_file_block(temp_data);
					}
					start = end;
					num++;
				}

				this.fun_up_file_savepath();
			},
			fun_up_file_block: async function(temp_data) {
				// console.log('点击上传附件');
				if (this.p3 == '') {
					this.p3 = GetShort("userno");
				}
				// console.log('p3=' + this.p3);
				let that = this;
				var postdata = "";

				let temp_filedata = await this.fun_blod_toString(temp_data);

				postdata =
					'{"user_no":"' +
					GetShort("userno") +
					'","upfile_name":"' +
					DeleteSpecialWord(this.file_name) +
					// '","upfile_type":"' +
					// this.file_type +
					// '","upfile_size":"' +
					// this.file_size +
					'","upfile_data":"' +
					temp_filedata +
					'","rowid":"' +
					this.row_id +
					'","sheet_no":"' +
					this.sheet_no +
					'","p1":"' +
					this.p1 +
					'","p2":"' +
					this.p2 +
					'","p3":"' +
					this.p3 +
					'"}';
				postdata =
					'{"method":"File_block","data":"' + base_encode(postdata) + '"}';

				return new Promise((resolve, reject) => {
					// console.log(menuvalue);
					that.$post(
						api.http_method, postdata
					).then(res => {
						res = JSON.parse(res);
						// console.log(res);

						resolve(res.data)
					})
				});

			},
			fun_blod_toString: function(fileData) {
				return new Promise((resolve, reject) => {

					let reader = new FileReader(); // FileReader
					reader.readAsDataURL(fileData);
					reader.onload = function() {
						// 获取到base64图片内容
						// console.log(this.result);
						// let f='';
						// f=ChangeSpecial(this.result);
						// console.log(f);
						resolve(this.result);
					}

				});
			},
			fun_up_file_savepath: function() {
				if (this.p3 == '') {
					this.p3 = GetShort("userno");
				}
				console.log('p3=' + this.p3);
				this.element_loading = true;

				var postdata = "";
				postdata =
					'{"action":"data_save_' + this.file_action + '","user_no":"' +
					GetShort("userno") +
					'","f_name":"' +
					DeleteSpecialWord(this.file_name) +
					'","f_type":"' +
					this.file_type +
					'","f_size":"' +
					this.file_size +
					'","f_path":"' +
					this.p1 + '/' + this.p2 + '/' + this.p3 + '/' + this.file_name +
					'","rowid":"' +
					this.row_id +
					'","sheet_no":"' +
					this.sheet_no +
					'","mode_type":"' +
					this.mode_type +
					'","mode_name":"' +
					this.mode_name +
					'"}';

				// console.log(postdata);
				postdata =
					'{"method":"File_NewSavePath","data":"' + base_encode(postdata) + '"}';


				let that = this;
				this.$post(
					api.http_method,
					postdata
				).then(res => {
					res = JSON.parse(res);
					res = res.data;
					this.element_loading = false;
					if (res.status == 1) {
						that.file_up = "上传成功";

						that.file_url = BackSpecial(res.f_url);
						that.file_src = BackSpecial(res.f_src);

						that.refresh_data();

						this.$message({
							message: '上传成功',
							type: 'success'
						});
					} else {
						this.file_up = "上传失败";

						this.$message({
							message: '上传失败\n\r' + res.msg,
							type: 'success'
						});
					}

				});

			},

		}
	};
</script>


<style scoped>
	.tanfile {
		display: -webkit-inline-box;
		max-height: 60vh;
		overflow: auto;
	}

	.pop_content {

		height: auto;
		/* background: #faf5f5; */
		background-color: rgb(195, 219, 250);
		position: fixed;
		border-radius: 3px;
		display: none;
		z-index: 1000;
		padding: 5px;
		overflow: hidden;

		display: inline-block;
		min-width: 720px;
		max-height: 80vh;
		/* overflow: auto; */
	}

	/* .pop_children{
	position: fixed;
	
	z-index: 9999;
} */
</style>